<template>
<div>
    <table>
    <pt-form-list-item label="拒绝理由:" :required="true">
        <wt-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}" v-model="rejectedReason"  data-vv-as="拒绝理由" name="rejectedReason"  v-validate="'required'"></wt-input>
    </pt-form-list-item>
    </table>
    <div class="button-div">
        <el-button type="primary" @click="rejectReview" :loading="loading">驳回</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
</div>
</template>
<script>
export default {
  props: {
    promotionDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      rejectedReason: '',
      loading: false
    }
  },
  methods: {
    rejectReview () {
      let status
      if (this.promotionDetail.promotionData && this.promotionDetail.promotionData.promotionType === 'CASH_BACK') {
        status = this.promotionDetail.status === 'WAITING_AUDIT' ? 'REJECTION' : (this.promotionDetail.status === 'WAITING_FINANCIAL_AUDIT' ? 'FINANCIAL_REJECTION' : null)
      } else {
        status = 'REJECTION'
      }
      let data = {
        status: status,
        id: this.promotionDetail.id,
        rejectedReason: this.rejectedReason
      }
      this.loading = true
      this.$store.dispatch('promotionStatus', data).then(res => {
        this.loading = false
        this.$message.success('驳回审核成功')
        this.$emit('close', true)
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '驳回审核失败')
      })
    },
    cancel () {
      this.$emit('close')
    }
  }
}
</script>
<style module lang="less">
</style>
